import { defineStore } from 'pinia'
import { computed, ref, watch } from 'vue'

export type ThemeMode = 'light' | 'dark'

const THEME_KEY = 'musex_theme'

const systemDark = (): boolean =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches

export const useThemeStore = defineStore('theme', () => {
  // 首次访问跟随系统偏好，之后以用户选择为准（localStorage）
  const stored = localStorage.getItem(THEME_KEY) as ThemeMode | null
  const mode = ref<ThemeMode>(stored ?? (systemDark() ? 'dark' : 'light'))

  const isDark = computed(() => mode.value === 'dark')

  function apply(val: ThemeMode) {
    const root = document.documentElement
    root.classList.toggle('dark', val === 'dark')
    root.style.colorScheme = val
  }

  watch(mode, (val) => {
    localStorage.setItem(THEME_KEY, val)
    apply(val)
  })

  function setMode(val: ThemeMode) {
    mode.value = val
  }

  function toggle() {
    mode.value = mode.value === 'dark' ? 'light' : 'dark'
  }

  /** 在应用启动时调用，把持久化的主题同步到 <html> */
  function init() {
    apply(mode.value)
  }

  return { mode, isDark, setMode, toggle, init }
})
